import { ApiBind, Common } from './common.model';
/**
 * 認証情報クラス
 * @remarks
 * APIからの認証情報を格納するクラス
 *
 */
export class AuthCredential extends Common {

  // 次アクション(認証系)
  @ApiBind({ column: 'next_action' })
  next_action: string;

}
